import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';
import { Container, Icon } from 'rsuite';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { getSidebarNavExpanded } from '../../../redux/Guest/selectors/components/page-layout';
import { toggleSidebarNav } from '../../../redux/Guest/actions/components/page-layout';
import { guestsBasePath, guestsCreatePath } from '../../../routes/Paths';
import { modifyAccess } from '../../../helpers/permission';
import { MODULE as GUEST_MODULE } from '../../../constants/permissions/guest';
import AccessControl from '../../AccessControl';
import MainLayout from '../../../containers/MainLayout';
import MainContent from '../../MainContent';
import SidebarNav from '../../SidebarNav';
import NavLink from '../../NavLink';
import { navKeysByPath, NAV_KEYS } from './nav-keys';

const GuestPageLayout = ({ children }) => {
  const dispatch = useDispatch();
  const { path } = useRouteMatch();
  const [activeKey, setActiveKey] = useState();
  const sidebarExpanded = useSelector(getSidebarNavExpanded);

  useEffect(
    () => {
      const navKey = get(path, navKeysByPath);
      if (navKey) setActiveKey(navKey);
    },
    [path]
  );

  const handleToggleSidebarNav = () => {
    dispatch(toggleSidebarNav());
  };

  return (
    <MainLayout>
      <MainContent>
        <SidebarNav
          activeKey={activeKey}
          expanded={sidebarExpanded}
          onToggle={handleToggleSidebarNav}
        >
          <AccessControl allowOnlyFor={modifyAccess(GUEST_MODULE)}>
            <NavLink
              to={guestsCreatePath}
              eventKey={NAV_KEYS.CREATE}
              icon={<Icon icon="file" />}
            >
              Create
            </NavLink>
          </AccessControl>
          <NavLink
            to={guestsBasePath}
            eventKey={NAV_KEYS.LIST}
            icon={<Icon icon="list" />}
          >
            Guests
          </NavLink>
        </SidebarNav>
        <Container>{children}</Container>
      </MainContent>
    </MainLayout>
  );
};

GuestPageLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default GuestPageLayout;
